import EducationFormPreview from "../EducationAndWork/EducationFormPreview";
import WorkExperienceFormPreview from "../EducationAndWork/WorkExperienceFormPreview";
import { useInterviewContext } from "../../InterviewContext";
import { useTranslation } from "react-i18next";
import "../../../styles/forms.scss";
import DisabledTextArea from "../../../../components/DisabledTextArea";

const EducationAndWorkTabPreview = ({ interview }) => {
  const { t } = useTranslation();

  return (
    <section className="edu-work">
      <h1>{t("Education and Work")}</h1>
      <div>
        {interview?.interviewEducation?.candidateCourses?.map(
          (course, index) => {
            return <EducationFormPreview candidateCourse={course} />;
          }
        )}
      </div>
      <div className="form-group">
        <div className="label-wrapper">
          <label htmlFor="notes">{t("Notes")}</label>
        </div>
        <DisabledTextArea
          id="notesOfFormation"
          name="notesOfFormation"
          value={interview.interviewEducation.notesOfFormation}
        />
      </div>
      <div>
        <WorkExperienceFormPreview work={interview.candidateWorkExperience} />
        <div>
          <div className="form-group">
            <div className="label-wrapper">
              <label htmlFor="personalProfile">{t("Personal Profile")}</label>
            </div>
            <DisabledTextArea
              value={interview.candidateWorkExperience?.personalProfile}
              name="personalProfile"
            />
          </div>
          <div className="form-group">
            <div className="label-wrapper">
              <label htmlFor="remarks">{t("Comments")}</label>
            </div>
            <DisabledTextArea
              value={interview.candidateWorkExperience?.remarks}
              name="remarks"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default EducationAndWorkTabPreview;
